(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minovia-product-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.minoviaProductDetailsReady === 'true') return;

      const nav = root.querySelector('[data-minovia-subnav]');
      const links = Array.from(root.querySelectorAll('[data-minovia-nav-link]'));
      if (!nav || links.length === 0) return;

      root.dataset.minoviaProductDetailsReady = 'true';

      const setActive = (id) => {
        links.forEach((link) => {
          const isActive = link.getAttribute('href').slice(1) === id;
          link.classList.toggle('is-active', isActive);

          if (isActive) {
            link.setAttribute('aria-current', 'location');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      };

      const getOffset = () => {
        const header = document.querySelector('header');
        const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        return Math.round(headerBottom + nav.getBoundingClientRect().height + 12);
      };

      links.forEach((link) => {
        link.addEventListener('click', (event) => {
          const targetId = link.getAttribute('href').slice(1);
          const target = document.getElementById(targetId);
          if (!target) return;

          event.preventDefault();
          window.scrollTo({
            top: window.scrollY + target.getBoundingClientRect().top - getOffset(),
            behavior: 'smooth',
          });
          setActive(targetId);
        });
      });

      if (!('IntersectionObserver' in window)) return;

      const targets = links
        .map((link) => document.getElementById(link.getAttribute('href').slice(1)))
        .filter(Boolean);

      const observer = new IntersectionObserver(
        (entries) => {
          const visibleEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

          if (visibleEntry) setActive(visibleEntry.target.id);
        },
        {
          rootMargin: '-' + getOffset() + 'px 0px -62% 0px',
          threshold: [0, 0.1, 0.4],
        }
      );

      targets.forEach((target) => observer.observe(target));
    };

    const initAll = () => {
      document.querySelectorAll('[data-minovia-product-details]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-minovia-product-details]')
        ? event.target
        : event.target.querySelector('[data-minovia-product-details]');
      init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
